import { useEffect } from "react";
import { useTeamsUserCredential } from "@microsoft/teamsfx-react";
import config from "./lib/config";
import Main from "./Main";
import { TeamsFxContext } from "./Context";
import { app } from "@microsoft/teams-js";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Login from "./Login";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "../authConfig";

const msalInstance = new PublicClientApplication(msalConfig);

const App = () => {
  const { loading, theme, themeString, teamsUserCredential } =
    useTeamsUserCredential({
      initiateLoginEndpoint: config.initiateLoginEndpoint!,
      clientId: config.clientId!,
    });

  useEffect(() => {
    if (loading) {
      console.log("Initializing Teams app...");
      app
        .initialize()
        .then(() => {
          console.log("Teams app initialized successfully");
          // Hide the loading indicator.
          app.notifySuccess();
        })
        .catch((error) => {
          console.error("Failed to initialize Teams app:", error);
        });
    }
  }, [loading]);

  // Log when teamsUserCredential changes
  useEffect(() => {
    console.log("teamsUserCredential changed:", !!teamsUserCredential);
  }, [teamsUserCredential]);

  return (
    <TeamsFxContext.Provider value={{ teamsUserCredential }}>
      <MsalProvider instance={msalInstance}>
        <Router>
          <Routes>
            <Route path="/" element={!loading && <Main />} />
            <Route path="/login" element={<Login />} />
          </Routes>
        </Router>
      </MsalProvider>
    </TeamsFxContext.Provider>
  );
};

export default App;
